import React from "react";
import ESIPage from "@/components/esi-page/ESIPage";

function generateMetadata() {
  return {
    title: "Declaration of Conformity",
    description: `John Lewis & Partners is obliged as a manufacturer to make these Declarations of Conformity publicly available on this page.`,
  };
}

function Page() {
  return <ESIPage />;
}

Page.generateMetadata = generateMetadata;

export default Page;
